import {
  Directive,
  Input,
  inject,
  effect,
  input,
  HostBinding,
  OnInit,
} from '@angular/core';
import { CollapsibleService } from './collapsible.service';
import { ResponsiveService } from '@/app/core/services/responsive.service';

@Directive({
  selector: '[rdoCollapsedCards]',
  standalone: true,
})
export class CollapsedCardsDirective {
  private collapsibleService = inject(CollapsibleService);
  private responsiveService = inject(ResponsiveService);

  rdoCollapsedCards = input.required<string>();

  @HostBinding('class.collapsed-cards') isCollapsed = false;
  @HostBinding('class.fixed-cards') isFixed = false;

  constructor() {
    // 2. Effects can now live in the constructor (correct injection context)
    effect(() => {
      const key = this.rdoCollapsedCards(); // Read the input signal

      // Since 'required' inputs might technically be uninitialized for a split microtask,
      // it's safe to check, though usually unnecessary with input.required
      if (key) {
        const stateSignal = this.collapsibleService.getState(key);

        // This tracks changes to BOTH the input key AND the service state
        this.isCollapsed = stateSignal();
        console.log('collapsed state=', this.isCollapsed);
      }
    });

    effect(() => {
      // This tracks changes to BOTH the input key (existence) AND isMobile
      if (this.rdoCollapsedCards()) {
        this.isFixed = this.responsiveService.isMobile();
        console.log('isMobile=', this.isFixed);
      }
    });
  }
}
